'use client';

import { useContext } from 'react';
import { CountryContext } from './CountryContext';

export const useCountry = () => {
    return useContext(CountryContext);
};
